import React from 'react';
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import createStore from '../store/IpRestrictionForm';
import IpRestrictionForm from '../components/IpRestrictionForm';

const IpRestrictionFormApp = (props, _railsContext) => {
  window.Constants = _railsContext.Constants;
  const store = createStore(props, _railsContext);

  const reactComponent = (
    <Provider {...{ store }}>
      <IpRestrictionForm />
    </Provider>
  );
	return reactComponent;
};

ReactOnRails.register({ IpRestrictionFormApp });
